/**
 * Разбирает время из поля «Начать с»: «90», «1:30» или «1:02:03».
 * Возвращает секунды или null, если ввод не похож на время.
 */
export function parseStartTime(text) {
  const parts = String(text || "")
    .trim()
    .split(":");

  if (parts.length > 3 || parts.some((part) => !/^\d+$/.test(part))) {
    return null;
  }

  return parts.reduce((total, part) => total * 60 + Number(part), 0);
}

/**
 * Ставит в ссылке параметр start (секунды), сохраняя остальные параметры.
 */
export function urlWithStart(url, seconds) {
  if (!url) return url;

  const [beforeHash, hash] = url.split("#");
  const [path, query = ""] = beforeHash.split("?");
  const params = new URLSearchParams(query);
  params.set("start", String(seconds));

  return `${path}?${params.toString()}${hash !== undefined ? `#${hash}` : ""}`;
}

/**
 * Подставляет start в src iframe внутри embed-кода.
 */
export function embedWithStart(code, seconds) {
  if (!code) return code;

  return code.replace(
    /src=(['"])(.*?)\1/,
    (match, quote, src) => `src=${quote}${urlWithStart(src, seconds)}${quote}`
  );
}
